var render = function render(_c,_vm){return _c('v-footer',{staticClass:"pa-3",attrs:{"fixed":"","app":""}},[_c('v-spacer'),_vm._v(" "),_c('div',[_vm._v("JOB24 EXCHANGE © "+_vm._s(new Date().getFullYear()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }